import { z } from 'zod';
/**
 * Contratos compartidos entre el navegador y la API.
 *
 * Un esquema por endpoint, definido UNA vez. Fastify valida la entrada contra
 * él y el frontend deriva sus tipos del mismo archivo: si un campo cambia, el
 * build del frontend falla. Es lo que reemplaza a los tipos generados de la
 * v1, sin paso de generación que se pueda olvidar.
 */
export const CODIGOS_ERROR = [
    'validacion',
    'no_autenticado',
    'sin_permiso',
    'no_encontrado',
    'conflicto',
    'demasiadas_peticiones',
    'no_disponible',
    'interno',
];
/**
 * Forma uniforme de error. Nunca lleva stack ni mensaje crudo del motor de
 * base de datos: eso va al log del servidor, no a la respuesta.
 */
export const esquemaError = z.object({
    error: z.object({
        codigo: z.enum(CODIGOS_ERROR),
        mensaje: z.string(),
        detalles: z.array(z.object({ campo: z.string(), mensaje: z.string() })).optional(),
    }),
});
/**
 * Paginación por cursor en TODO listado, con tope duro.
 *
 * Ningún endpoint devuelve una tabla completa. En la v1 una consulta sin
 * filtro chocaba contra el límite de filas de la API y devolvía un subconjunto
 * en silencio, lo que corrompía los reportes de contribución sin avisar.
 */
export const LIMITE_PAGINA_DEFECTO = 50;
export const LIMITE_PAGINA_MAXIMO = 200;
export const esquemaConsultaPagina = z.object({
    cursor: z.string().max(64).optional(),
    limit: z.coerce
        .number()
        .int()
        .min(1)
        .max(LIMITE_PAGINA_MAXIMO)
        .default(LIMITE_PAGINA_DEFECTO),
});
export function esquemaPagina(item) {
    return z.object({
        datos: z.array(item),
        /** null cuando no hay más páginas. */
        siguienteCursor: z.string().nullable(),
    });
}
//# sourceMappingURL=comun.js.map